import React, { useEffect, useState } from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Painel";
import TicketResponsiveContainer from "../pages/TicketResponsiveContainer";
import Cadastro from "../pages/Cadastro";
import Obrigado from "../pages/Obrigado";
import PaginaAfiliado from "../pages/PaginaAfiliado";
import Login from "../pages/Login";
import MobileLogin from "../pages/MobileLogin";
import Canais from "../pages/Canais";
import SettingsCustom from "../pages/SettingsCustom";
import PixelsPage from "../pages/PixelsPage";
import Financeiro from "../pages/Financeiro";
import EiPaguei from "../pages/EiPaguei";
import Users from "../pages/Users";
import Contatos from "../pages/Contatos";
import ContactImportPage from "../pages/Contatos/import";
import ChatMoments from "../pages/Moments"
import Departamentos from "../pages/Departamentos";
import Etiquetas from "../pages/Etiquetas";
import DocumentacaoPage from "../pages/Documentacao";
import ApiClientesPage from "../pages/api-clientes";
import ApiMensagensPage from "../pages/api-mensagens";
import ApiContatosPage from "../pages/api-contatos";
import ApiTagsPage from "../pages/api-tags";
import ApiProdutosPage from "../pages/api-produtos";
import ApiServicosPage from "../pages/api-servicos";
import ApiUsuariosPage from "../pages/api-usuarios";
import ApiFilasPage from "../pages/api-filas";
import ApiNegociosPage from "../pages/api-negocios";
import ApiTagsKanbanPage from "../pages/api-tags-kanban";
import InstagramPage from "../pages/Instagram";
import TemplatesPage from "../pages/Templates";
import ApiProjetosPage from "../pages/api-projetos";
import ApiTarefasPage from "../pages/api-tarefas";
import ApiTicketsPage from "../pages/api-tickets";
import ApiConexoesPage from "../pages/api-conexoes";
import ApiFaturasPage from "../pages/api-faturas";
import PublicApiDocs from "../pages/PublicApiDocs";
import Helps from "../pages/Helps";
import ContactLists from "../pages/ContactLists";
import ContactListItems from "../pages/ContactListItems";
import Companies from "../pages/Companies";
import RespostasRapidas from "../pages/RespostasRapidas";
import { AuthProvider } from "../context/Auth/AuthContext";
import { PagePermissionsProvider } from "../context/PagePermissionsContext";
import { PlanPermissionsProvider } from "../context/PlanPermissionsContext";
import { TicketsContextProvider } from "../context/Tickets/TicketsContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import Route from "./Route";
import ProtectedRoute from "../components/ProtectedRoute";
import Schedules from "../pages/Lembretes";
import Campanhas from "../pages/Campanhas";
import CampaignsConfig from "../pages/CampaignsConfig";
import CampaignReport from "../pages/CampaignReport";
import Annoucements from "../pages/Annoucements";
import Faturas from "../pages/Faturas";
import DetalhesFaturas from "../pages/Faturas/detalhesFaturas";
import ContasFinanceiras from "../pages/ContasFinanceiras";
import Chat from "../pages/Chat";
import Agentes from "../pages/Agentes";
import BasesConhecimento from "../pages/BasesConhecimento";
import ForgetPassword from "../pages/ForgetPassWord/";
import VerificarEmail from "../pages/VerificarEmail";
import AllConnections from "../pages/AllConnections";
import Reports from "../pages/Relatorios";
import ConversasRelatorio from "../pages/ConversasRelatorio";
import RelatorioAtendentes from "../pages/RelatorioAtendentes";
import RelatorioTags from "../pages/RelatorioTags";
import RelatorioTagsKanban from "../pages/RelatorioTagsKanban";
import RelatorioFaturas from "../pages/RelatorioFaturas";
import RelatorioCampanhas from "../pages/RelatorioCampanhas";
import RelatorioChamadas from "../pages/RelatorioChamadas";
import RelatorioAgendamentos from "../pages/RelatorioAgendamentos";
import RelatorioOrdensServico from "../pages/RelatorioOrdensServico";
import Fiscal from "../pages/Fiscal";
import Planilhas from "../pages/Planilhas";
import Tarefas from "../pages/Tarefas";
import EmailInbox from "../pages/EmailInbox";
import { FlowBuilderConfig } from "../pages/FlowBuilderConfig";
import FlowBuilder from "../pages/fluxos";
import FlowDefault from "../pages/FlowDefault"
import AutomacaoFrase from "../pages/AutomacaoFrase";
import Subscription from "../pages/Subscription";
import QueueIntegration from "../pages/Integracao";
import Files from "../pages/Files";
import Produtos from "../pages/Produtos";
import CatalogoProdutos from "../pages/CatalogoProdutos";
import Kanban from "../pages/Kanban";
import TagsKanban from "../pages/TagsKanban";
import empresa from "../pages/Empresa";
import IaWorkflows from "../pages/IaWorkflows";
import IaWorkflowEditor from "../pages/IaWorkflowEditor";
import TutorialVideos from "../pages/TutorialVideos";
import SliderBannersPage from "../pages/SliderBanners";
import AppMarketplace from "../pages/AppMarketplace";
import AppMarketplaceAdmin from "../pages/AppMarketplaceAdmin";
import AppMarketplaceDetail from "../pages/AppMarketplaceDetail";
import CompanyPopupsAdmin from "../pages/CompanyPopupsAdmin";
import SupportTickets from "../pages/SupportTickets";
import SupportTicketsAdmin from "../pages/SupportTicketsAdmin";
import ServicosPage from "../pages/Servicos";
import ServiceOrdersPage from "../pages/ServiceOrders";
import ProfissionaisPage from "../pages/Profissionais";
import Automations from "../pages/Automations";
import Sistema from "../pages/Sistema";
import PaymentSettings from "../pages/PaymentSettings";
import IntegrationSettings from "../pages/IntegrationSettings";
import FerramentasPage from "../pages/Ferramentas";
import ContactSettings from "../pages/ContactSettings";
import ContactAnalytics from "../pages/ContactAnalytics";
import Leads from "../pages/Leads";
import Clients from "../pages/Clientes";
import Grupos from "../pages/Grupos";
import ClientDetails from "../pages/ClientDetails";
import Projects from "../pages/Projects";
import GoogleMyNegocio from "../pages/Marketing/GoogleMyNegocio";
import MetaAds from "../pages/Marketing/MetaAds";
import GoogleAds from "../pages/Marketing/GoogleAds";
import BlogPage from "../pages/Blog";
import Poster from "../pages/Marketing/Poster";
import BlogPost from "../pages/BlogPost";
import QuizList from "../pages/Quiz";
import QuizBuilder from "../pages/QuizBuilder";
import QuizPublic from "../pages/QuizPublic";
import QuizRespostas from "../pages/QuizRespostas";
import ProjectDetails from "../pages/ProjectDetails";
import UserSchedules from "../pages/Agendas";
import Agenda from "../pages/Agenda";
import CallHistory from "../pages/CallHistory";
import Afiliados from "../pages/Afiliados";
import MeuPlano from "../pages/MeuPlano";
import TranslationManager from "../pages/TranslationManager";
import WhitelabelPage from "../pages/WhitelabelPage";
import LandingPageAdmin from "../pages/LandingPageAdmin";
import IntegracoesDisponiveis from "../pages/IntegracoesDisponiveis";
import EmpresasPage from "../pages/EmpresasPage";
import EmpresaDetalhes from "../pages/EmpresaDetalhes";
import EmpresaDocumentos from "../pages/EmpresaDocumentos";
import PlanosPage from "../pages/PlanosPage";
import CreditosIA from "../pages/CreditosIA";
import AdminCreditosIA from "../pages/AdminCreditosIA";
import AdminAfiliados from "../pages/AdminAfiliados";
import AdminComissoes from "../pages/AdminComissoes";
import AdminSaques from "../pages/AdminSaques";
import AdminAfiliadoDetalhes from "../pages/AdminAfiliadoDetalhes";
import ContratosPage from "../pages/Contratos";
import ContratoModelos from "../pages/ContratoModelos";

import Funil from "../pages/Funil";
import LandingPage from "../pages/landingpage";
import FeatureMarketing from "../pages/landingpage/FeatureMarketing";
import FeatureVendas from "../pages/landingpage/FeatureVendas";
import FeatureSuporte from "../pages/landingpage/FeatureSuporte";
import TermsOfService from "../pages/landingpage/TermsOfService";
import UsagePolicy from "../pages/landingpage/UsagePolicy";
import PrivacyPolicy from "../pages/landingpage/PrivacyPolicy";
import PublicCheckout from "../pages/PublicCheckout";
import AssinarContrato from "../pages/AssinarContrato";
import Atendimentos from "../pages/Atendimentos";
import { QueueSelectedProvider } from "../context/QueuesSelected/QueuesSelectedContext";
const Routes = () => {
  const [showCampaigns, setShowCampaigns] = useState(false);

  useEffect(() => {
    const cshow = localStorage.getItem("cshow");
    if (cshow !== undefined) {
      setShowCampaigns(true);
    }
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <PagePermissionsProvider>
          <PlanPermissionsProvider>
            <TicketsContextProvider>
              <Switch>
            <Route exact path="/" component={LandingPage} isPublic />
            <Route exact path="/login" component={Login} isPublic />
            <Route exact path="/funcionalidades/marketing" component={FeatureMarketing} isPublic />
            <Route exact path="/funcionalidades/vendas" component={FeatureVendas} isPublic />
            <Route exact path="/funcionalidades/suporte" component={FeatureSuporte} isPublic />
            <Route exact path="/docs/public/api" component={PublicApiDocs} isPublic />
            <Route exact path="/termos-de-servico" component={TermsOfService} isPublic />
            <Route exact path="/politica-de-uso" component={UsagePolicy} isPublic />
            <Route exact path="/politica-de-privacidade" component={PrivacyPolicy} isPublic />
            <Route exact path="/mobile-login" component={MobileLogin} isPublic />
            <Route exact path="/cadastro" component={Cadastro} isPublic />
            <Route exact path="/obrigado" component={Obrigado} isPublic />
            <Route exact path="/p/:slug" component={PaginaAfiliado} isPublic />
            <Route exact path="/forgetpsw" component={ForgetPassword} isPublic />
            <Route exact path="/verificar-email" component={VerificarEmail} isPublic />
            <Route exact path="/checkout/:token" component={PublicCheckout} isPublic />
            <Route exact path="/public/checkout/:token" component={PublicCheckout} isPublic />
            <Route exact path="/blog/:slug" component={BlogPost} isPublic />
            <Route exact path="/q/:slug" component={QuizPublic} isPublic />
            <Route exact path="/assinar/:slug" component={AssinarContrato} isPublic />

            <WhatsAppsProvider>
              <QueueSelectedProvider>
              <LoggedInLayout>
                <ProtectedRoute exact path="/financeiro" component={Financeiro} planFlag="financeiro" />
                <ProtectedRoute exact path="/eipaguei" component={EiPaguei} />
                <ProtectedRoute exact path="/fiscal" component={Fiscal} planFlag="financeiro" />
                <ProtectedRoute exact path="/planilhas" component={Planilhas} planFlag="integrations" />

                <ProtectedRoute exact path="/companies" component={Companies} />
                <ProtectedRoute exact path="/empresas" component={EmpresasPage} />
                <ProtectedRoute exact path="/empresas/:id" component={EmpresaDetalhes} />
                <ProtectedRoute exact path="/empresas/:id/documentos" component={EmpresaDocumentos} />
                <ProtectedRoute exact path="/planos" component={PlanosPage} />
                <ProtectedRoute exact path="/creditos-ia" component={CreditosIA} planFlag="openAi" />
                <ProtectedRoute exact path="/admin/creditos-ia" component={AdminCreditosIA} />
                <ProtectedRoute exact path="/dashboard" component={Dashboard} />
                <ProtectedRoute exact path="/painel" component={Dashboard} />
                <ProtectedRoute exact path="/tickets/:ticketId?" component={TicketResponsiveContainer} />
                <ProtectedRoute exact path="/conversas/:ticketId?" component={TicketResponsiveContainer} />
                <ProtectedRoute exact path="/grupos/:ticketId?" component={Grupos} />
                <ProtectedRoute exact path="/atendimentos/:ticketId?" component={Atendimentos} />
                <ProtectedRoute exact path="/connections" component={Canais} />
                <ProtectedRoute exact path="/canais" component={Canais} />
                <ProtectedRoute exact path="/respostas-rapidas" component={RespostasRapidas} />
                <ProtectedRoute exact path="/todolist" component={Produtos} planFlag="produtos" />
                <ProtectedRoute exact path="/produtos" component={Produtos} planFlag="produtos" />
                <ProtectedRoute exact path="/catalogo-produtos" component={CatalogoProdutos} planFlag="produtos" />
                <ProtectedRoute exact path="/schedules" component={Schedules} />
                <ProtectedRoute exact path="/lembretes" component={Schedules} />
                <ProtectedRoute exact path="/tags" component={Etiquetas} />
                <ProtectedRoute exact path="/etiquetas" component={Etiquetas} />
                <ProtectedRoute exact path="/contacts" component={Contatos} />
                <ProtectedRoute exact path="/contatos" component={Contatos} />
                <ProtectedRoute exact path="/contacts/import" component={ContactImportPage} />
                <ProtectedRoute exact path="/contatos/import" component={ContactImportPage} />
                <ProtectedRoute exact path="/helps" component={Helps} />
                <ProtectedRoute exact path="/users" component={Users} />
                <ProtectedRoute exact path="/messages-api" component={DocumentacaoPage} />
                <ProtectedRoute exact path="/messages-api/documentacao" component={ApiClientesPage} />
                <ProtectedRoute exact path="/api-mensagens" component={ApiMensagensPage} />
                <ProtectedRoute exact path="/api-contatos" component={ApiContatosPage} />
                <ProtectedRoute exact path="/api-tags" component={ApiTagsPage} />
                <ProtectedRoute exact path="/api-produtos" component={ApiProdutosPage} />
                <ProtectedRoute exact path="/api-servicos" component={ApiServicosPage} />
                <ProtectedRoute exact path="/api-usuarios" component={ApiUsuariosPage} />
                <ProtectedRoute exact path="/api-filas" component={ApiFilasPage} />
                <ProtectedRoute exact path="/api-negocios" component={ApiNegociosPage} />
                <ProtectedRoute exact path="/api-tags-kanban" component={ApiTagsKanbanPage} />
                <ProtectedRoute exact path="/instagram" component={InstagramPage} />
                <ProtectedRoute exact path="/modelos" component={TemplatesPage} />
                <ProtectedRoute exact path="/api-projetos" component={ApiProjetosPage} />
                <ProtectedRoute exact path="/api-tarefas" component={ApiTarefasPage} />
                <ProtectedRoute exact path="/api-tickets" component={ApiTicketsPage} />
                <ProtectedRoute exact path="/api-conexoes" component={ApiConexoesPage} />
                <ProtectedRoute exact path="/api-faturas" component={ApiFaturasPage} />
                <ProtectedRoute exact path="/settings" component={SettingsCustom} />
                <ProtectedRoute exact path="/pixels" component={PixelsPage} />
                <ProtectedRoute exact path="/queues" component={Departamentos} />
                <ProtectedRoute exact path="/departamentos" component={Departamentos} />
                <ProtectedRoute exact path="/relatorios" component={Reports} />
                <ProtectedRoute exact path="/relatorios/conversas" component={ConversasRelatorio} />
                <ProtectedRoute exact path="/relatorios/atendentes" component={RelatorioAtendentes} />
                <ProtectedRoute exact path="/relatorios/tags" component={RelatorioTags} />
                <ProtectedRoute exact path="/relatorios/kanban" component={RelatorioTagsKanban} planFlag="crm" />
                <ProtectedRoute exact path="/relatorios/faturas" component={RelatorioFaturas} planFlag="financeiro" />
                <ProtectedRoute exact path="/relatorios/campanhas" component={RelatorioCampanhas} />
                <ProtectedRoute exact path="/relatorios/chamadas" component={RelatorioChamadas} />
                <ProtectedRoute exact path="/relatorios/agendamentos" component={RelatorioAgendamentos} />
                <ProtectedRoute exact path="/relatorios/ordens-servico" component={RelatorioOrdensServico} />
                <ProtectedRoute exact path="/tarefas" component={Tarefas} planFlag="tarefas" />
                <ProtectedRoute exact path="/email-inbox" component={EmailInbox} />
                <ProtectedRoute exact path="/sistema" component={Sistema} />
                <ProtectedRoute exact path="/ferramentas" component={FerramentasPage} planFlag="automacao" />
                <ProtectedRoute exact path="/queue-integration" component={QueueIntegration} planFlag="integrations" />
                <ProtectedRoute exact path="/integracao" component={QueueIntegration} planFlag="integrations" />
                <ProtectedRoute exact path="/announcements" component={Annoucements} />
                <ProtectedRoute exact path="/faturas" component={Faturas} planFlag="financeiro" />
                <ProtectedRoute exact path="/faturas/:id" component={DetalhesFaturas} planFlag="financeiro" />
                <ProtectedRoute exact path="/contas" component={ContasFinanceiras} planFlag="financeiro" />
                <ProtectedRoute exact path="/documentacao" component={Funil} planFlag="crm" />
                <ProtectedRoute exact path="/funil" component={Funil} planFlag="crm" />
                <ProtectedRoute exact path="/empresa" component={empresa} />
                <ProtectedRoute exact path="/payment-settings" component={PaymentSettings} />
                <ProtectedRoute
                  exact
                  path="/integration-settings"
                  component={IntegrationSettings}
                />

                <ProtectedRoute
                  exact
                  path="/automacao-frase"
                  component={AutomacaoFrase}
                />
                <ProtectedRoute
                  exact
                  path="/fluxos"
                  component={FlowBuilder}
                  planFlag="automacao"
                />
                <ProtectedRoute
                  exact
                  path="/flowbuilder/:id?"
                  component={FlowBuilderConfig}
                  planFlag="automacao"
                />
                <ProtectedRoute exact path="/chats/:id?" component={Chat} />
                <ProtectedRoute exact path="/files" component={Files} />
                <ProtectedRoute exact path="/moments" component={ChatMoments} />
                <ProtectedRoute exact path="/Kanban" component={Kanban} planFlag="crm" />
                <ProtectedRoute exact path="/TagsKanban" component={TagsKanban} planFlag="crm" />
                <ProtectedRoute exact path="/prompts" component={Agentes} />
                <ProtectedRoute exact path="/agentes" component={Agentes} />
                <ProtectedRoute exact path="/bases-conhecimento" component={BasesConhecimento} planFlag="automacao" />
                <ProtectedRoute exact path="/ia-workflows" component={IaWorkflows} />
                <ProtectedRoute exact path="/ia-workflows/:id" component={IaWorkflowEditor} />
                <ProtectedRoute exact path="/tutorial-videos" component={TutorialVideos} />
                <ProtectedRoute exact path="/slider-banners" component={SliderBannersPage} />
                <ProtectedRoute exact path="/app-marketplace" component={AppMarketplace} />
                <ProtectedRoute exact path="/app-marketplace-admin" component={AppMarketplaceAdmin} />
                <ProtectedRoute exact path="/app-marketplace/:id" component={AppMarketplaceDetail} />
                <ProtectedRoute exact path="/company-popups-admin" component={CompanyPopupsAdmin} />
                <ProtectedRoute exact path="/support-tickets" component={SupportTickets} />
                <ProtectedRoute exact path="/support-tickets-admin" component={SupportTicketsAdmin} />
                <ProtectedRoute exact path="/servicos" component={ServicosPage} planFlag="servicos" />
                <ProtectedRoute exact path="/ordens-servico" component={ServiceOrdersPage} planFlag="ordemDeServico" />
                <ProtectedRoute exact path="/profissionais" component={ProfissionaisPage} planFlag="ordemDeServico" />
                <ProtectedRoute exact path="/leads" component={Leads} />
                <ProtectedRoute exact path="/clientes" component={Clients} />
                <ProtectedRoute exact path="/clientes/:clientId" component={ClientDetails} />
                <ProtectedRoute exact path="/projects" component={Projects} planFlag="projetos" />
                <ProtectedRoute exact path="/projetos" component={Projects} planFlag="projetos" />
                <ProtectedRoute exact path="/projects/:projectId" component={ProjectDetails} planFlag="projetos" />
                <ProtectedRoute exact path="/agendas" component={UserSchedules} planFlag="agenda" />
                <ProtectedRoute exact path="/marketing/google-meu-negocio" component={GoogleMyNegocio} planFlag="marketing" />
                <ProtectedRoute exact path="/marketing/meta-ads" component={MetaAds} planFlag="marketing" />
                <ProtectedRoute exact path="/marketing/google-ads" component={GoogleAds} planFlag="marketing" />
                <ProtectedRoute exact path="/marketing/blog" component={BlogPage} />
                <ProtectedRoute exact path="/marketing/poster" component={Poster} />
                <ProtectedRoute exact path="/captacao/quiz" component={QuizList} />
                <ProtectedRoute exact path="/captacao/quiz/:id/editar" component={QuizBuilder} />
                <ProtectedRoute exact path="/captacao/quiz/:id/respostas" component={QuizRespostas} />
                <ProtectedRoute exact path="/agentamentos" component={Agenda} planFlag="agenda" />
                <ProtectedRoute exact path="/compromissos" component={Agenda} planFlag="agenda" />
                <ProtectedRoute exact path="/automations" component={Automations} />
                <ProtectedRoute exact path="/allConnections" component={AllConnections} />
                <ProtectedRoute
                  exact
                  path="/subscription"
                  component={Subscription}
                />
                <ProtectedRoute exact path="/contact-settings" component={ContactSettings} />
                <ProtectedRoute exact path="/contact-analytics" component={ContactAnalytics} />
                <ProtectedRoute exact path="/call-history" component={CallHistory} />
                <ProtectedRoute exact path="/chamadas" component={CallHistory} />
                <ProtectedRoute exact path="/afiliados" component={Afiliados} />
                <ProtectedRoute exact path="/meu-plano" component={MeuPlano} />
                <ProtectedRoute exact path="/admin/afiliados/:id" component={AdminAfiliadoDetalhes} />
                <ProtectedRoute exact path="/admin/afiliados" component={AdminAfiliados} />
                <ProtectedRoute exact path="/admin/comissoes" component={AdminComissoes} />
                <ProtectedRoute exact path="/admin/saques" component={AdminSaques} />
                <ProtectedRoute exact path="/contratos" component={ContratosPage} />
                <ProtectedRoute exact path="/contrato-modelos" component={ContratoModelos} />
                <ProtectedRoute exact path="/translation-manager" component={TranslationManager} />
                <ProtectedRoute exact path="/whitelabel" component={WhitelabelPage} />
                <ProtectedRoute exact path="/landing-admin" component={LandingPageAdmin} />
                <ProtectedRoute exact path="/integracoes-disponiveis" component={IntegracoesDisponiveis} />
                {showCampaigns && (
                  <>
                    <ProtectedRoute exact path="/contact-lists" component={ContactLists} />
                    <ProtectedRoute exact path="/contact-lists/:contactListId/contacts" component={ContactListItems} />
                    <ProtectedRoute exact path="/campaigns" component={Campanhas} />
                    <ProtectedRoute exact path="/campanhas" component={Campanhas} />
                    <ProtectedRoute exact path="/campaign/:campaignId/report" component={CampaignReport} />
                    <ProtectedRoute exact path="/campaigns-config" component={CampaignsConfig} />
                  </>
                )}
              </LoggedInLayout>
              </QueueSelectedProvider>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer position="top-center" autoClose={3000} />
        </TicketsContextProvider>
        </PlanPermissionsProvider>
        </PagePermissionsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
